import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'

export const guidesApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'guidesApi',
  tagTypes: ['Guides', 'Guide'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listGuides: builder.query({
      query: (params) => {
        return {
          url: '/v1/guides',
          method: 'GET',
          params
        }
      },
      providesTags: ['Guides']
    }),
    getGuideById: builder.query({
      query: (id) => `/v1/guides/${id}`,
      providesTags: ['Guide']
    }),
    createGuide: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/guides',
          method: 'POST',
          body: payload
        }
      },
      invalidatesTags: ['Guides']
    }),
    updateGuide: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data

        return {
          url: `/v1/guides/${id}`,
          method: 'PATCH',
          body: payload
        }
      },
      invalidatesTags: ['Guide']
    }),
    deleteGuide: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/guides/${id}`,
          method: 'DELETE'
        }
      },
      invalidatesTags: ['Guides', 'Guide']
    }),
    uploadImage: builder.mutation({
      query: (data) => {
        return {
          url: 'v1/guides/steps/upload/',
          method: 'POST',
          body: data
        }
      },
      invalidatesTags: ['Guide']
    }),
    createGuideStep: builder.mutation({
      query: (data) => {
        const { guideId, ...payload } = data
        return {
          url: `v1/guides/${guideId}/steps/`,
          method: 'POST',
          body: payload
        }
      },
      invalidatesTags: ['Guide']
    }),
    updateGuideStep: builder.mutation({
      query: (data) => {
        const { id, guideId, ...payload } = data
        return {
          url: `v1/guides/${guideId}/steps/${id}`,
          method: 'PATCH',
          body: payload
        }
      },
      invalidatesTags: ['Guide']
    }),
    deleteGuideStep: builder.mutation({
      query: (data) => {
        const { guideId, guideStepId } = data
        return {
          url: `v1/guides/${guideId}/steps/${guideStepId}`,
          method: 'DELETE'
        }
      },
      invalidatesTags: ['Guide']
    })
  })
})

export const {
  useListGuidesQuery,
  useGetGuideByIdQuery,
  useCreateGuideMutation,
  useUpdateGuideMutation,
  useDeleteGuideMutation,
  useUploadImageMutation,
  useCreateGuideStepMutation,
  useUpdateGuideStepMutation,
  useDeleteGuideStepMutation
} = guidesApi

export default guidesApi
